import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AprovedInstallflow } from "@/components/installFlowV2/aproved-install-flow";

export const Route = createFileRoute("/installFlow/aproved-install-flow")({
  component: AprovedInstallflow,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
});
